/* esm.sh - applesauce-content@5.0.0/dist/nast/find-and-replace */
export * from "/*applesauce-content@5.0.0/esnext/dist/nast/find-and-replace.mjs";
